import { MediaType } from '@msdyn365-commerce/retail-proxy';

export enum FileType {
    Pdf = 'pdf',
    Image = 'image',
    Video = 'video',
    Unknown = 'unknown'
}

export interface FileTypeResult {
    type: FileType;
    extension: string | null;
}

const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'tiff', 'svg'];
const videoExtensions = ['mp4', 'mov', 'avi', 'mkv', 'webm', 'wmv'];

export const getFileType = (altText?: string, uri?: string, mediaTypeValue?: number): FileTypeResult => {
    if (mediaTypeValue !== undefined && mediaTypeValue !== null) {
        const ext = getExtension(altText, uri);
        switch (mediaTypeValue) {
            case MediaType.Image:
                return { type: FileType.Image, extension: ext };
            case MediaType.Video:
                return { type: FileType.Video, extension: ext };
            case MediaType.File: {
                return { type: FileType.Pdf, extension: ext };
            }
            case MediaType.None:
            default:
                break;
        }
    }

    const ext = getExtension(altText, uri);
    if (ext === FileType.Pdf || ['pdf'].includes(ext || '')) {
        return { type: FileType.Pdf, extension: ext };
    }
    if (imageExtensions.includes(ext || '')) {
        return { type: FileType.Image, extension: ext };
    }
    if (videoExtensions.includes(ext || '')) {
        return { type: FileType.Video, extension: ext };
    }
    return { type: FileType.Unknown, extension: ext };
};

export const getMediaTypeFromValue = (val: FileTypeResult): MediaType => {
    const ext = val.extension?.toLowerCase();

    if (ext && imageExtensions.includes(ext)) {
        return MediaType.Image;
    }
    if (ext && videoExtensions.includes(ext)) {
        return MediaType.Video;
    }
    if (ext) {
        return MediaType.File;
    }
    return MediaType.None;
};

const getExtension = (altText?: string, uri?: string): string | null => {
    const filename = (altText || uri || '').toLowerCase();
    const match = filename.match(/\.([a-z0-9]+)$/);
    return match ? match[1] : null;
};
